import { render } from "./home-lesson.vue?vue&type=template&id=66553549"
import script from "./home-lesson.vue?vue&type=script&lang=js"
export * from "./home-lesson.vue?vue&type=script&lang=js"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__